import { isEmpty, isEqual, isNil, isString } from 'lodash';
import { humanReadableDuration } from '@shared/util/durations';
import { EditableField, Field } from './Field';

export interface ScheduledAutomation {
  automationTriggerDurations: string[];
}

export class ScheduledAutomationField implements EditableField {
  readonly durations: string[];
  readonly fieldType = 'ScheduledAutomationField';

  constructor(durations: string[]) {
    this.durations = durations;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof ScheduledAutomationField && isEqual(this.durations, field.durations);
  }

  toFieldJson(): ScheduledAutomation {
    return { automationTriggerDurations: this.durations };
  }

  toDisplayString(): string {
    return this.durations.map(humanReadableDuration).join(', ');
  }

  get isEmpty() {
    return isEmpty(this.durations);
  }

  static fromFieldJson(jsonBlob: any): ScheduledAutomationField | null {
    if (isScheduledAutomation(jsonBlob)) {
      return new ScheduledAutomationField(jsonBlob.automationTriggerDurations);
    } else {
      return null;
    }
  }
}

function isScheduledAutomation(jsonBlob: any): jsonBlob is ScheduledAutomation {
  return (
    !isNil(jsonBlob) &&
    Array.isArray(jsonBlob.automationTriggerDurations) &&
    jsonBlob.automationTriggerDurations.every(isString)
  );
}
